import { ChangeDetectionStrategy, Component, Input, output, inject, input } from '@angular/core';

import { ActivitySubscriptionType } from '@core/activities-types';
import type { ActivitySubscriptions, ActivitySubscriptionUpdateData } from '@core/activities-types';
import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { FeatureCode } from '@core/feature-spec-types';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import { ReferralsService } from '@core/referrals-legacy';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-follow-offer',
  templateUrl: './activity-subscriptions-follow-offer.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActivitySubscriptionsTableComponent,
    ActivitySubscriptionsTableRowComponent,
    TranslatePipe,
  ],
})
export class ActivitySubscriptionsFollowOfferComponent {
  private readonly i18n = inject(I18nService);
  private readonly referralsService = inject(ReferralsService);
  private readonly featureSpecDataHelpers = inject(FeatureSpecFacade);

  @Input()
  public set types(types: ActivitySubscriptionType[]) {
    this.title = types.includes(ActivitySubscriptionType.Slack)
      ? this.i18n.translate('app.subscriptions.follow_offer_slack_v2')
      : this.i18n.translate('app.subscriptions.follow_offer_v2');
    this._types = types;
  }

  public get types(): ActivitySubscriptionType[] {
    return this._types;
  }

  public readonly activitySubscriptions = input<ActivitySubscriptions>(undefined!);
  public readonly hasOverdueCandidates = input<boolean>(true);
  public readonly hasRequisitions = input<boolean>(false);
  public readonly abilities = input({
    viewOffers: false,
    viewCandidates: false,
    manageJobsReferralSettings: false,
    viewRequisitions: false,
    viewAcquisition: false,
  });
  public changeEvents = output<ActivitySubscriptionUpdateData>();

  public title: string;

  public canManageCandidates: boolean = false;
  public hasReferrals: boolean = this.referralsService.hasReferralsAndReferralsFlag();

  protected isScreeningAssistantEnabled = this.featureSpecDataHelpers.selectIsEnabled(
    FeatureCode.AiCandidateScreening,
  );
  protected isMatchingAssistantEnabled = this.featureSpecDataHelpers.selectIsEnabled(
    FeatureCode.AiCandidateMatching,
  );
  private _types: ActivitySubscriptionType[];
}
